import React from 'react';
import { assertNever } from '../../../utils/helpers';

import { museum } from '../../../data';
import { RIntroContentLocalMuseumTranscriptionDemo } from './r-intro-content-local-museum-demo';
import { RIntroContentLocalMuseumTranscriptionBrighton } from './r-intro-content-local-museum-brighton';
import { RIntroContentLocalMuseumTranscriptionMunch } from './r-intro-content-local-museum-munch';
import { RIntroContentLocalMuseumTranscriptionCop26 } from './r-intro-content-local-museum-cop26';


const Transcript = (museum.slug === 'demo') ? RIntroContentLocalMuseumTranscriptionDemo
                 : (museum.slug === 'brighton') ? RIntroContentLocalMuseumTranscriptionBrighton
                 : (museum.slug === 'munch') ? RIntroContentLocalMuseumTranscriptionMunch
                 : (museum.slug === 'mpu') ? RIntroContentLocalMuseumTranscriptionDemo
                 : (museum.slug === 'cop-26') ? RIntroContentLocalMuseumTranscriptionCop26
                 : assertNever(museum.slug);


const RIntroContentLocalMuseumTranscription: React.FC = () => {
  return <Transcript />;
};

export {
  RIntroContentLocalMuseumTranscription,
};
